<template>
  <div v-if="fase" class="lavorazioni-sub">
    <common-hero :tag="'div'" :background="{desktop: fase.coverDesk && fase.coverDesk.responsiveImage ? fase.coverDesk.responsiveImage.src : pageApiData.cover.desktop, mobile: fase.coverMobile && fase.coverMobile.responsiveImage ? fase.coverMobile.responsiveImage.src : pageApiData.cover.mobile  }" :hasClass="'--vh100'">
      <span
        class="common-hero__processing-order"
        style="margin-bottom: 0"
      >
        {{ $t('comeFunzionaSubs.fase') }} 0{{ fase.position }}
      </span>
      <h1 v-html="fase.titolo"></h1>
      <div class="schema-fase flex-right">
        <img v-if="fase.svgCover" :src="fase.svgCover.url">
      </div>
    </common-hero>

    <div>
      <template v-if="fase && fase.videoLink !== '' && fase.videoId">
      <ecogas-video class="hide-to-mobile"  :videoId="fase.videoId"
      :playerOptions="{
        loop: true,
          controls: false,
          preload: 'auto',
          sources: [
              {
                src: `${fase.videoLink}#t=0.5`,
                type: 'video/mp4'
              }
            ]
      }"/>
        </template>
      <section class="padding-paragrafo padding-paragrafo--less padding-paragrafo--less--no-top lavorazioni-content-area padding-top-mobile">
        <div class="default-container">
          <h2 class="text-to-uppercase" v-if="fase.intro !== ''" v-html="fase.intro" />
          <div v-if="fase.titleContent !== ''" v-html="fase.titleContent" />
          <div  v-if="fase.iconTabs && fase.iconTabs.length > 0">
            <ul class="icons-set">
              <li v-for="icon in fase.iconTabs" :key="icon.text">
                <div>
                <img v-if="icon.svg" :src="icon.svg.url" :alt="icon.text" class="icon-img"/>
                <span class="text-to-uppercase" v-html="icon.text ? icon.text.replace(/\n/g, '<br>') : ''"/>
                </div>
              </li>
            </ul>
          </div>
         <div v-if="fase.contentText !== ''">
          <div v-if="fase.doubleColumn" v-html="fase.contentText" class="double-column" />
          <div v-else v-html="fase.contentText" />
         </div>
          <template v-if="viewport.label === 'mobile'">
             <img v-if="fase.imageMobile" :src="fase.imageMobile.responsiveImage ? fase.imageMobile.responsiveImage.src : fase.imageMobile.url" :alt="fase.intro"/>
          </template>
          <template v-else>
           <img v-if="fase.image" :src="fase.image.responsiveImage ? fase.image.responsiveImage.src : fase.image.url" :alt="fase.intro"/>
          </template>
        </div>
      </section>
      <template v-if="fase.backgroundImageBlock && fase.backgroundImageBlock.length > 0">
        <template v-if="viewport.label === 'desktop'">
           <section  v-for="(block, index) in fase.backgroundImageBlock" :key="index"
            class="padding-paragrafo paragrafo-h-p paragrafo-h-p--greener font-white hasUl"
            :style="block.backgroundImageDesk && block.backgroundImageDesk.responsiveImage ? `background-color: #EFEFEC; background-image: url('${block.backgroundImageDesk.responsiveImage.src}'); background-position: center center; background-size: cover;` : ''">
              <div
              v-animate-on-intersection
              class="default-container">
              <div class="less-text-width" >
                <div v-if="block.titolo !== ''" v-html="block.titolo" />
                <ul v-if="block.list && block.list.length > 0">
                  <li v-for="(item, indexList) in block.list" :key="indexList" v-html="item.elementoLista" class="list-background-image"/>
                </ul>
              </div>
            </div>
          </section>
        </template>
        <template v-else>
          <section  v-for="(block, index) in fase.backgroundImageBlock" :key="index"
          class="padding-paragrafo paragrafo-h-p paragrafo-h-p--greener font-white hasUl"
          :style="block.backgroundImageMobile && block.backgroundImageMobile.responsiveImage ? `background-color: #EFEFEC; background-image: url('${block.backgroundImageMobile.responsiveImage.src}'); background-position: center center; background-size: cover;` : ''">
            <div
              v-animate-on-intersection
              class="default-container">
              <div class="less-text-width" >
                <div v-if="block.titolo !== ''" v-html="block.titolo" />
                <ul v-if="block.list && block.list.length > 0">
                  <li v-for="(item, indexList) in block.list" :key="indexList" v-html="item.elementoLista" class="list-background-image"/>
                </ul>
              </div>
            </div>
          </section>
      </template>
      </template>
      <div class="sticky-prev-next-menu">
        <div class="default-container">
          <div class="sticky-prev-next-menu__links-container">
            <router-link :to="{ name: `${lang}-come-funziona` }">
              <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="SIMBOLI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="sticky-navigation-bar" transform="translate(-281.000000, -33.000000)" fill="#FFF">
                        <g id="Group">
                            <g transform="translate(281.000000, 33.000000)">
                                <rect id="Rectangle" x="0" y="0" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-3" x="0" y="6" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-6" x="0" y="12" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy" x="6" y="0" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-4" x="6" y="6" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-7" x="6" y="12" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-2" x="12" y="0" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-5" x="12" y="6" width="3" height="3"></rect>
                                <rect id="Rectangle-Copy-8" x="12" y="12" width="3" height="3"></rect>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
            </router-link>
            <ul>
              <li>
                <router-link v-if="previous"
                  :to="{ name: `${lang}-come-funziona-sub`, params: { type: previous.slug } }"
                  class="sticky-prev-next-menu__previous text-to-uppercase">
                  <img src="/come-funziona/arrow-top-white.svg" width="17px" height="17px" alt="arrow.top" />
                  {{ previous.titolo }}
                </router-link>
              </li>
              <li>
                <router-link v-if="next"
                  :to="{ name: `${lang}-come-funziona-sub`, params: { type: next.slug } }"
                  class="sticky-prev-next-menu__next text-to-uppercase">
                  {{ next.titolo }}
                  <img src="/come-funziona/arrow-top-white.svg" width="17px" height="17px" alt="arrow.top" />
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import lang from '@/views/mixins/lang'
import { mapGetters, mapActions } from 'vuex'
import store from '../store'
import { SET_GLOBAL_LOADING } from '../store/mutation-types'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import EcogasVideo from '@/components/EcogasVideoJs'
import { fasiData } from '@/queries/fasi.js'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    CommonHero,
    EcogasVideo
  },
  data: () => ({
    fase: {},
    allFasis: [],
    seo: {},
    slugLocales: {}
  }),
  apollo: {
    fasi: {
      query: fasiData,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale,
          slug: this.$route.params.type
        }
      },
      result (result) {
        if (result.data) {
          this.fase = result.data.fasi
          this.seo = this.fase.seo
          this.allFasis = result.data.allFasis
          this.slugLocales = this.fase._allSlugLocales.reduce((acc, fase) => Object.assign({}, acc, { [fase.locale]: fase.value.toLowerCase() }), {})
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'viewport',
      'processingsExcerpts'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    processingsQuery: {
      get () {
        return { pageName: 'processings', lang: this.lang || 'en' }
      }
    },
    processingsList: {
      get () {
        return this.page(this.lang, 'processings').sections || []
      }
    },
    previous: {
      get () {
        const prev = this.fase ? this.fase.position - 1 : -1
        let prevItem
        if (prev > 0) {
          prevItem = this.allFasis && this.allFasis.length > 0 ? this.allFasis.find(item => item.position === prev) : ''
        } else {
          prevItem = this.allFasis && this.allFasis.length > 0 ? this.allFasis.find(item => item.position === this.allFasis.length) : ''
        }
        return prevItem
        /* const prevIndex = this.processingsList.indexOf(this.pageApiData.slug) - 1
        const prevSlug = this.processingsList[prevIndex <= 0 ? this.processingsList.length - 1 : prevIndex]
        if (typeof prevSlug !== 'undefined') return _.find(this.processingsExcerpts(this.lang), ({ slug }) => slug === prevSlug) */
      }
    },
    next: {
      get () {
        const next = this.fase ? this.fase.position + 1 : 1
        let nextItem
        const total = this.allFasis && this.allFasis.length > 0 ? this.allFasis.length : 0
        if (next <= total) {
          nextItem = this.allFasis.find(item => item.position === next)
        } else {
          nextItem = total > 0 ? this.allFasis.find(item => item.position === 1) : undefined
        }
        return nextItem
        /* const prevIndex = this.processingsList.indexOf(this.pageApiData.slug) + 1
        const prevSlug = this.processingsList[prevIndex >= this.processingsList.length ? 0 : prevIndex]
        if (typeof prevSlug !== 'undefined') return _.find(this.processingsExcerpts(this.lang), ({ slug }) => slug === prevSlug) */
      }
    },
    bgImage: {
      get () {
        if (this.pageApiData.coverSecondArea) return `${this.imgServer}${this.pageApiData.coverSecondArea[this.viewport.label]}`
        return ''
      }
    },
    getBackgroundCss: {
      get () {
        if (this.pageApiData.coverSecondArea) return `background-color: #EFEFEC; background-image: url('${this.bgImage}'); background-position: center center; background-size: cover;`
        return ''
      }
    }
  },
  async beforeRouteUpdate (to, from, next) {
    // set env to loading
    store.commit(SET_GLOBAL_LOADING, true)

    // extract language
    const lang = _.split(to.name, '-')[0] || 'en'

    // start loading
    await store.dispatch('loadPageData', { pageName: to.meta.pageName, lang, type: to.params.type })

    store.commit(SET_GLOBAL_LOADING, false)

    if (to.hash) this.$_scrollToHash(to.hash)
    next()
  },
  methods: {
    ...mapActions([
      'loadProcessingsExcerpts'
    ]),
    $_loadProcessings (query) {
      this.loadPageData(query)
    }
  },
  watch: {
    processingsQuery: {
      handler (query) {
        this.$_loadProcessings(query)
      },
      immediate: true,
      deep: true
    },
    processingsList: {
      handler (list) {
        store.commit(SET_GLOBAL_LOADING, true)
        this.loadProcessingsExcerpts({
          lang: this.lang,
          filter: list
        })
        store.commit(SET_GLOBAL_LOADING, false)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";
  @import "../assets/mixins/common";

  .sticky-prev-next-menu{
    width: 100%;
    position: sticky;
    bottom: 0;
    background-color: #30AE8D;
    z-index: 10;
    .sticky-prev-next-menu__links-container{
      width: 100%; display: flex; flex-wrap: nowrap;
      justify-content: space-between;
      height: 80px; align-items: center;
      ul{
        margin: 0; padding: 0;
        display: flex;
        li{
          @media #{$small_mq} {
            max-width: 150px;
          }
          a{
            text-decoration: none;
            display: inline-block;
            transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
          }
          .sticky-prev-next-menu__previous{
            color: #FFF;
            border-right: 1px solid #FFF;
            padding: 3px 10px 3px 0;
            img {
              width: 12px; height: 12px;
              transform: rotate3d(0, 0, 1, -90deg);
              margin: 0 6px 0 0;
            }
          }

          .sticky-prev-next-menu__previous:hover, .sticky-prev-next-menu__next:hover{
            opacity: .8;
          }
          .sticky-prev-next-menu__next{
            color: #FFF;
            padding: 3px 0px 3px 10px;
            img {
              width: 12px; height: 12px;
              transform: rotate3d(0, 0, 1, 90deg);
              margin: 0 0 0 6px;
            }
          }
        }
      }
    }
  }

  .lavorazioni-sub-content{
    background-color: #EFEFEC;
    padding: 8rem 0 4rem;

    @media #{$medium_mq} {
       padding: 10rem 0 4rem;
    }

    @media #{$large_mq} {
       padding: 14rem 0 4rem;
    }

    p{
      padding: 2rem 0;
      margin: 0;

      @media #{$medium_mq} {
        padding: 3rem 0;
        padding-left: 10%;
      }

      @media #{$xlarge_mq} {
        padding-left: 10%;
      }

    }

    p:first-child{
      font-size: 3rem;
      line-height: 1.4;
      color: #FFF;
      font-weight: 100;
      padding-top: .8rem;
      @media #{$medium_mq} {
        padding-left: 0;
      }

      @media #{$xlarge_mq} {
        font-size: 4.8rem;
        padding-left: 0;
      }
    }

    strong{
      color: #5530FF;
      font-weight: 100;
    }

  }

  .lavorazioni-content-area{
    background-color: #EFEFEC;
    h2{
      @include section-title(#343434);
      margin: 0;
    }
    h3 {
      font-size: 1.3rem;
      line-height: 1.3;
      font-family: 'IBM Plex Sans Condensed', sans-serif;
      font-weight: 300;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.65rem;
      }
      @media #{$large_mq} {
        font-size: 2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 2.5rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 2.8125rem;
      }
    }
    p{
      font-size: 1rem;
      line-height: 1.6;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.1rem;
      }
      @media #{$large_mq} {
        font-size: 1.2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 1.35rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 1.5rem;
      }
    }
    ul li{
      @include hero-small-p(#343434);
    }
    .double-column{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      p {
        width: 90%;
      }
      @media #{$large_mq} {
        flex-wrap: nowrap;
        p {
          width: 45%;
        }
      }
    }
    .icons-div-set{
      width: auto;
      li {
        justify-items: stretch;
        padding: 52px 0;
        background-color: #FFF;
        display: block;
        text-align: center;
        img{
          margin-bottom: 40px;
          width: auto;
        }
        span{
          width: 100%;
          display: block;
          font-size: .9rem;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          text-transform: uppercase;
          color: #343434;
          padding: 0 20px;
          @media #{$medium_mq} {
            font-size: .95rem;
          }
          @media #{$large_mq} {
            font-size: 1.05rem;
          }
          @media #{$xlarge_mq} {
            font-size: 1.15rem;
          }
          @media #{$xxlarge_mq} {
            font-size: 1.25rem;
          }
        }
      }
    }
    img:not(.icon-img) {
      width: 100%;
      height: auto;
      margin: 3rem auto;
      @media #{$large_mq} {
        margin: 4rem 0;
        max-width: 1000px;
        width: 100%;
      }
      @media #{$xlarge_mq} {
        margin: 5rem 0;
      }
      @media #{$xxlarge_mq} {
        margin: 6rem 0;
      }
      @media #{$large_mq_max} {
        max-width: 500px;
        width: 100%;
        display: block;
        margin-top: 100px;
      }
    }
  }

  .richiesta-informazioni{
    background-color: #EFEFEC;
    padding: 6rem 0 8rem;
    text-align: center;
    border-top: 1px solid #4A4A4A;
    border-bottom: 1px solid #4A4A4A;

    @media #{$large_mq} {
      padding: 8rem 0 10rem;
    }

    p{
      font-size: 3rem;
      line-height: 1.4;
      color: #FFF;
      font-weight: 100;
      margin-bottom: 4rem;

      @media #{$medium_mq} {
        text-align: center;
        max-width: 500px;
        margin: 2rem auto 5rem;
      }
      @media #{$xlarge_mq} {
        font-size: 4.2rem;
        max-width: 700px;
      }
    }
    button{
      font-size: 1.8rem;
      border: 0;
      background-color: #304FFE;
      color: #FFF;
      border-radius: 28px;
      padding: 1.6rem 1.8rem 2rem 3.2rem;
      display: inline-block;
      width: 100%;
      cursor: pointer;
      margin-top: 1rem;
      font-weight: 300;

      @media #{$medium_mq} {
        width: 312px;
      }
    }
    img{
      margin-left: 1rem;
      vertical-align: middle;
      top: -3px;
    }
  }

  .lavorazioni-sub .common-hero h2{
    margin-bottom: 0;
  }

  .lavorazioni-sub .common-hero p{
    line-height: 1.8;
    margin-bottom: 0;
  }
  .schema-fase {
    img {
      width: 100%;
      height: auto;
      margin-bottom: 80px;
      @media #{$medium_mq} {
        width: 50%;
        margin-bottom: 60px;
      }
      @media #{$large_mq} {
        width: 50%;
        margin-bottom: 40px;
      }
    }
  }

  .paragrafo-h-p.font-white ul li.list-background-image p{
     @include hero-small-p(#FFF);
  }

</style>
